import { ExchangeError } from '@exodus/exchange-client-providers';
export class ExchangeCancelError extends ExchangeError {
    name = 'Exchange Cancel Error';
}
export class QuoteNotFoundError extends ExchangeError {
    name = 'Quote Not Found Error';
}
export class MissingProviderTxsError extends ExchangeError {
    name = 'Missing Txs Error';
}
export class UnknownTx extends ExchangeError {
    name = 'Unknown Tx';
}
